import React, { FC, useState } from 'react';
import { Button, Dropdown, Menu } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { mapToMenuWithDivider } from 'common/helpers/common.helper';
import { ITEMS_FOR_VIEW_LIMIT_4 } from 'common/config';
import { ERoute } from 'common/const';
import { ReactComponent as MenuIcon } from 'app/assets/images/redesign/menu.svg';
import { ReactComponent as CloseIcon } from 'app/assets/images/redesign/close.svg';
import { useAppSelector } from 'app/store/store.hooks';
import { getCatalogMenuItems } from 'entities/Catalog/Catalog.helper';
import { selectCatalogList, selectIsCatalogLoading } from 'entities/Catalog/Catalog.slice';

interface IComponentProps {
  catalogId?: number;
}

export const CatalogSelector: FC<IComponentProps> = ({ catalogId }) => {
  // catalog
  const catalogList = useAppSelector(selectCatalogList);
  const isCatalogLoading = useAppSelector(selectIsCatalogLoading);

  const [open, setOpen] = useState<boolean>(false);
  const location = useLocation();
  const navigate = useNavigate();

  const selectedKeys = catalogId ? [String(catalogId)] : [];
  const feedCatalogList = mapToMenuWithDivider(getCatalogMenuItems(catalogList.filter((catalog) => !!catalog.sellerId)));
  const systemCatalogList = mapToMenuWithDivider(getCatalogMenuItems(catalogList.filter((catalog) => !catalog.sellerId)));

  const handleSelect = (key: string) => {
    navigate(`${ERoute.Catalog}/${key}`, { state: location.state });
    setOpen(false);
  };

  return (
    <Dropdown
      overlayClassName="redesign"
      open={open}
      onOpenChange={setOpen}
      trigger={['click']}
      dropdownRender={() => {
        if (!feedCatalogList.length && !systemCatalogList.length) {
          return (
            <div className="custom-dropdown catalog-selector__dropdown-container">
              <span className="text-lists color-dark-grey">В списке нет вариантов.</span>
            </div>
          );
        }

        return (
          <div className="custom-dropdown catalog-selector__dropdown">
            <div
              className={`catalog-selector__dropdown-wrapper ${
                feedCatalogList.length > ITEMS_FOR_VIEW_LIMIT_4 || systemCatalogList.length > ITEMS_FOR_VIEW_LIMIT_4
                  ? 'custom-dropdown__scrollable scrollbar'
                  : ''
              }`}
            >
              <div className="catalog-selector__dropdown-container">
                <span className="text-tag-accent color-bright-green custom-dropdown__title">Каталоги поставщиков</span>

                <Menu items={feedCatalogList} onClick={({ key }) => handleSelect(key)} selectedKeys={selectedKeys} />
              </div>

              {!!systemCatalogList.length && (
                <div className="catalog-selector__dropdown-container">
                  <span className="text-tag-accent color-bright-green custom-dropdown__title">Отрасли</span>

                  <Menu items={systemCatalogList} onClick={({ key }) => handleSelect(key)} selectedKeys={selectedKeys} />
                </div>
              )}
            </div>
          </div>
        );
      }}
      disabled={isCatalogLoading}
    >
      <Button
        className={`button-sm ${open ? 'success' : 'primary'}`}
        icon={open ? <CloseIcon className="icon-close-white" /> : <MenuIcon className="icon-menu-white" />}
      >
        Каталог
      </Button>
    </Dropdown>
  );
};
